import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaBell } from "react-icons/fa";

import { subscribeMediaErrorLog, markMediaErrorsRead } from "../../lib/MediaErrorLog";
import MediaErrorLogPanel from "./MediaErrorLogPanel";

/**
 * 재생 실패/통신 오류가 1건이라도 쌓이면 하단 툴바 위, 우측에 떠서 나타나는 알림 벨.
 * 오류가 없으면 아예 렌더링하지 않는다. 새 오류가 들어오면 빨간 점이 깜빡이고,
 * 벨을 클릭해 로그 패널을 열람하면 깜빡임만 멈춘다(점 자체는 오류가 남아있는 한 계속 표시).
 *
 * @since 2026-09-04.
 */
const MediaErrorBell = () => {
    const { t } = useTranslation();
    const [snapshot, setSnapshot] = useState({ count: 0, hasUnread: false });
    const [isPanelOpen, setIsPanelOpen] = useState(false);

    useEffect(() => subscribeMediaErrorLog(setSnapshot), []);

    if (snapshot.count === 0) return null;

    const handleClick = () => {
        markMediaErrorsRead();
        setIsPanelOpen(true);
    };

    return (
        <React.Fragment>
            <button
                type="button"
                className="media-error-bell"
                aria-label={t("오류_알림", { ns: "live" })}
                title={t("오류_알림", { ns: "live" })}
                onClick={handleClick}
            >
                <FaBell aria-hidden="true" />
                <span className={"media-error-bell-dot" + (snapshot.hasUnread ? " unread" : "")} />
            </button>
            <MediaErrorLogPanel isOpen={isPanelOpen} onClose={() => setIsPanelOpen(false)} />
        </React.Fragment>
    );
};

export default MediaErrorBell;
